import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/BlogCard/BlogCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
